import React from 'react';

export const TaskContext = React.createContext<{
  taskTodoOrOverdueCount: number;
  fetchTodoOrOverdueCount(): void;
}>({ taskTodoOrOverdueCount: 0, fetchTodoOrOverdueCount: () => undefined });
TaskContext.displayName = 'TaskContext';

export default TaskContext;
